import { AREA } from "./area";
import { DATA } from "./data";
import { DISTANCE } from "./distance";
import { ENERGY } from "./energy";
import { MASS } from "./mass";
import { POWER } from "./power";
import { PRESSURE } from "./pressure";
import { SPEED } from "./speed";
import { TEMPERATURE } from "./temperature";
import type { Category, Unit } from "./unit";
import { VOLUME } from "./volume";

// What a metre measures, then what fills it, then what it takes to move and what that costs, then the one quantity
// of the ten that nothing was ever poured into.
export const CATEGORIES: Category[] = [
  DISTANCE,
  AREA,
  VOLUME,
  MASS,
  TEMPERATURE,
  SPEED,
  DATA,
  ENERGY,
  POWER,
  PRESSURE,
];

export const CATEGORY_OPTIONS = CATEGORIES.map(({ id, label }) => ({ value: id, label }));

// One of something is what a conversion table is read for, so the page opens on it rather than on an empty box.
export const DEFAULT_AMOUNT = "1";

// Both fall back rather than fail, which is what makes a hash naming a category or a unit that has since gone a page
// that opens on the defaults instead of one that does not open.
export function pickCategory(id: string | null | undefined): Category {
  return CATEGORIES.find((category) => category.id === id) ?? CATEGORIES[0];
}

export function pickUnit(category: Category, id: string | null | undefined): Unit {
  return category.units.find((unit) => unit.id === id)
    ?? category.units.find((unit) => unit.id === category.defaultUnit)
    ?? category.units[0];
}

export function unitOptions(category: Category) {
  return category.units.map((unit) => ({ value: unit.id, label: `${unit.name} (${unit.symbol})` }));
}
